import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { Card, useOutsideClick } from 'tea-component';
import { connect } from 'umi'
import FilterBase from './FilterBase';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import { FilterProps } from './types';
import useFilter from './hooks/useFilter';

import './index.scss'
import { FilterTitle } from './FilterTitle';
import useStickyFilter from './hooks/useStickyFilter';

const contextMap = {}
export const getContext = (pageId: any) => {
  if (contextMap[pageId]) return contextMap[pageId];
  const context = createContext({});
  contextMap[pageId] = context;
  return contextMap[pageId]
}

export const filterContext = createContext({});

// hook 的方式获取 filter 数据
export const useFilterData = (pageId) => {
  if (!contextMap[pageId]) return
  const formState: any = useContext(contextMap[pageId])
  return formState
}
const defaultStickyProps = { isExpand: false, setIsExpand: () => { }, isHover: false, setIsHover: () => { }, isSticky: false, top: '60px', stickyClass: '', isRealtime: false }
const FilterWrapper = (props: FilterProps) => {
  const filterRef = useRef(null)
  const stickyFilterRef = useRef(null)
  const {
    isLocal = true,
    value,
    noCache,
    topSlot,
    options, //筛选器组件子props
    // onInit,
    onInnerChange,   //筛选器内部状态变化事件
    gameCode,
    confirmDisabled = false,
    filterRef: ref = filterRef,
    timeTypeList,
    isCeil = false,
    stickyProps = defaultStickyProps,
    latestTimeDate,
  } = props;
  const {
    loading,
    componentLoading,
    defaultValue,
    inputList,
    latestDate,
    onFilterConfirm,
    onFilterReset,
  } = useFilter(props, ref);
  const [showBubble, setShowBubble] = useState(false)
  const [changeFormValue, setChangeFormValue] = useState({})
  // const { listen } = useOutsideClick(stickyFilterRef);
  // listen(() => isExpand && setIsExpand(false));
  const { stickyProps: stickyFilterProps } = useStickyFilter(isCeil)
  const { isSticky: noTabSticky, top: noTabTop } = stickyFilterProps
  const { isExpand, setIsExpand, isHover, setIsHover, stickyClass, isRealtime, isSticky: tabSticky, top: tabTop } = stickyProps
  const hasTab = stickyClass?.includes('contentHead-normal')
  const isSticky = hasTab ? tabSticky : noTabSticky
  const top = hasTab ? tabTop : noTabTop
  const closeFunc = () => {
    try {
      const newFormValue: any = {}
      Object.keys(value)?.map(item => {
        newFormValue[item] = changeFormValue[item]
      })
      const isChange = JSON.stringify(value) !== JSON.stringify(newFormValue)
      if (isChange) {
        !showBubble && setShowBubble(true)
        if (showBubble && isExpand) {
          setIsExpand(false)
          setShowBubble(false)
        }
      } else {
        isExpand && setIsExpand(false)
        isExpand && setShowBubble(false)
      }
    } catch (error) {
      isExpand && setIsExpand(false)
      isExpand && setShowBubble(false)
    }
  }

  return (
    <div className={isCeil ? `filter-sticky-height${hasTab ? "-has-tab" : ""}` : ""}>
      {/*<DataTotip gameCode={gameCode}/>*/}
      <Card
        id='dbd-filter'
        className={isCeil ? isExpand ? 'dbd-filter-expand-content' : `dbd-filter-content ${isHover ? 'dbd-sticky-filter-hover' : ''}` : ''}
        style={isCeil ? { top: top, paddingBottom: isExpand || isSticky ? '0' : '4px' } : {}}
        ref={stickyFilterRef}
        onClick={() => {
          if (isCeil && !isExpand) {
            setIsExpand(true)
            setIsHover(false)
          }
        }}
        onMouseEnter={() => {
          isCeil && !isExpand && setIsHover(true);
        }}
        onMouseLeave={() => {
          isCeil && !isExpand && setIsHover(false)
        }}
      >
        <Card.Body style={(isRealtime ? isSticky ? false : true : true) ? {} : { padding: 0 }}>
          <Abnormal
            isLoading={loading}
            // componentLoading={componentLoading}
            style={{ height: isCeil ? 25 : 92 }}
            component={(
              <>
                <div className={isExpand || (isSticky && isRealtime) ? 'dbd-sticky-filter-none' : 'dbd-sticky-filter-block'}>
                  {isCeil && (isRealtime ? isSticky ? false : true : true) && <FilterTitle gameCode={gameCode} originFormValue={defaultValue} formValue={value} changeFormValue={changeFormValue} />}
                </div>
                <FilterBase
                  className={isCeil ? isExpand ? 'dbd-sticky-filter-block' : 'dbd-sticky-filter-none' : ''}
                  gameCode={gameCode}
                  value={value}
                  isExpand={isExpand}
                  showBubble={showBubble}
                  setShowBubble={setShowBubble}
                  setChangeFormValue={setChangeFormValue}
                  closeFunc={closeFunc}
                  defaultValue={defaultValue}
                  noCache={noCache}
                  loading={loading}
                  topSlot={topSlot}
                  options={options}
                  isLocal={isLocal}
                  inputList={inputList}
                  timeTypeList={timeTypeList}
                  latestDate={latestTimeDate ? latestTimeDate : latestDate}
                  confirmDisabled={confirmDisabled}
                  onConfirm={onFilterConfirm}
                  onReset={onFilterReset}
                  onInnerChange={onInnerChange}
                />
              </>
            )}
          />
        </Card.Body>
      </Card>
      <div
        className={isCeil ? isExpand ? 'dbd-sticky-filter-cover' : 'dbd-sticky-filter-none' : ''}
        onClick={closeFunc}
      />
    </div>
  )
}

export default connect((state: any) => {
  return {
    gameCode: state.dashboard?.currentGame?.game_code,
    groupByOption: state.dashboard?.groupByOption,
    filterSelectorData: state.dashboard?.filterSelectorData,
  }
})(FilterWrapper)
